import "./SectionConventionNextSteps.scss";

export default {
  root: "im-section-convention-next-steps",
  col: "im-section-convention-next-steps__col",
  illustration: "im-section-convention-next-steps__illustration",
  illustrationWrapper: "im-section-convention-next-steps__illustration-wrapper",
  title: "im-section-convention-next-steps__title",
};
